import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

import { INTERVENINGNAME, getInterveningTypeIdForName } from '@shared/models/constants/interveningType';
import { getMaritalIdForName } from '@shared/models/constants/martitalStatus';
import { List } from '@shared/models/interfaces/List.interface';
import { Intervener } from '@shared/models/interfaces/survey.interface';
import { SurveysService } from '@shared/providers/surveys.service';
import { UtilsService } from '@shared/providers/utils.service';
import { SurveyState } from '@shared/store/survey/survey.state';

import { SurveyInterveningFormComponent } from 'src/app/shared/components/forms/survey-intervening-form/survey-intervening-form.component';

@Component({
  selector: 'app-detail-intervening',
  templateUrl: './detail-intervening.component.html',
  styleUrls: ['./detail-intervening.component.scss'],
})
export class DetailInterveningComponent implements OnInit {
  @Input() intervener: Intervener[];
  @Input() surveyId;

  @Output() surveyData = new EventEmitter();
  @Output() idsToDelete = new EventEmitter();

  @ViewChild('interveningForm')
  public interveningInformationsForm!: SurveyInterveningFormComponent;
  public reports: List<any>;
  public loading = true;
  public message = '';
  public isDisabled = false;
  public survey;

  constructor(
    private utils: UtilsService,
    private translate: TranslateService,
    private store: Store,
    private surveyService: SurveysService
  ) {}

  async ngOnInit() {
    try {
      const data = await this.surveyService.getById(this.surveyId);
      this.survey = data.data.survey;
      this.isDisabled = this.store.selectSnapshot(SurveyState.getIsSigned);
    } catch (e) {
      console.error(e);
    } finally {
      await this.utils.dismissLoading();
      this.loading = false;
    }
  }

  getInterveningTypeName(interveningType: number): string {
    return this.translate.instant(INTERVENINGNAME[interveningType]);
  }

  async submit() {
    if (this.interveningInformationsForm.intervenerForm.invalid) {
      this.utils.validateAllFields(this.interveningInformationsForm.intervenerForm);
    } else {
      const interveningRawValue = this.interveningInformationsForm.intervenerForm.getRawValue();
      const intervener: Intervener[] = this.prepareInterveningData(interveningRawValue);
      this.surveyData.emit(intervener);
    }
  }

  private prepareInterveningData(interveningRawValue: any): Intervener[] {
    const interveners: Intervener[] = [];
    const interveningKeys = Object.keys(interveningRawValue);
    this.message = `${this.translate.instant('COMPONENTS.THE_FOLLOWING_PLAYERS')}`;
    interveningKeys.forEach(element => {
      let regex = /guarantor1|[a-z, P]+/g;
      let type = regex.exec(element);
      interveners.push({
        intervenerId: interveningRawValue[element].id,
        intervenerTypeId: getInterveningTypeIdForName(type[0]),
        intervenerRg: interveningRawValue[element].rg,
        intervenerName: interveningRawValue[element].name,
        intervenerEmail: interveningRawValue[element].email,
        intervenerDocument: this.utils.unmask(interveningRawValue[element].document),
        intervenerProfession: interveningRawValue[element].profession,
        intervenerNationality: interveningRawValue[element].nationality,
        intervenerNaturalness: interveningRawValue[element].naturalness,
        maritalStatusId: getMaritalIdForName(interveningRawValue[element].marital),
        intervenerPosition: interveningRawValue[element].position,
      });
      if (interveningRawValue[element]) {
        interveners.push({
          intervenerId: interveningRawValue[element].idPartner,
          intervenerTypeId: getInterveningTypeIdForName(type[0] + 'Partner'),
          intervenerRg: interveningRawValue[element].rgPartner,
          intervenerName: interveningRawValue[element].namePartner,
          intervenerEmail: interveningRawValue[element].emailPartner,
          intervenerDocument: this.utils.unmask(interveningRawValue[element].documentPartner),
          intervenerProfession: interveningRawValue[element].professionPartner,
          intervenerNationality: interveningRawValue[element].nationalityPartner,
          intervenerNaturalness: interveningRawValue[element].naturalnessPartner,
          maritalStatusId: getMaritalIdForName(interveningRawValue[element].maritalPartner),
          intervenerPosition: interveningRawValue[element].position,
        });
      }
    });
    this.message = this.message.slice(0, -1);
    this.message += `${this.translate.instant('COMPONENTS.CONFIRM_DELETION')}`;
    return interveners;
  }

  handleDelete(ids: number[]) {
    this.idsToDelete.emit(ids);
  }

  confirmDeletion(ids: number[]) {
    if (this.interveningInformationsForm) {
      this.interveningInformationsForm.confirmDeletion(ids);
    }
  }
}
